import '@ali/aps-dev/dist/css/aps.css';
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import CheckList from './CheckList';
import ScreenBar from './ScreenBar';
import './screen.scss';

@inject('resultListStore', 'checkListStore')
@observer
class Screen extends Component {
  constructor(props) {
    super(props);
    this.checkListStore = this.props.checkListStore;
    this.resultListStore = this.props.resultListStore;
    this.handlerShowCheckList = this.checkListStore.handlerShowCheckList.bind(this.checkListStore);
    this.barInfo = {
      'isShowCheckList': this.checkListStore.isShowCheckList,
      'handlerShowCheckList': this.handlerShowCheckList
    };
  }

  render() {
    const totalNum = this.resultListStore.totalPage;
    return (
      <div className="screen-title">
        <ScreenBar barInfo={this.barInfo} totalNum={totalNum} />
        <div className={this.checkListStore.isShowCheckList ? '' : 'checkListHide'}>
          <CheckList />
        </div>
      </div>
    );
  }
}
export default Screen;


// WEBPACK FOOTER //
// ./src/components/Screen/Screen.js